import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M12 20.25c-4.55 0-8.25-3.7-8.25-8.25S7.45 3.75 12 3.75s8.25 3.7 8.25 8.25-3.7 8.25-8.25 8.25m0-15.476c-3.984 0-7.226 3.241-7.226 7.226S8.015 19.226 12 19.226s7.226-3.241 7.226-7.226S15.985 4.774 12 4.774"
}), 'RadioButtonEmpty');
//# sourceMappingURL=index.js.map